import * as React from "react";

// import { IFancyDropdownOption } from "../../../classes/fancyDropdownOption";

import { FancyDropdownAlignment } from "./FancyDropdown";
import { FancyDropdownOption, IFancyDropdownOptionProps } from "./FancyDropdownOption";

const getDIVCSS = (alignment: FancyDropdownAlignment, optionalClassName: string) => {
  // Set CSS classname that sets left/right alignment of dropdown.
  let alignCSS = "";
  if (alignment && alignment === FancyDropdownAlignment.right) {
    alignCSS += " ";
    alignCSS += "CAL-DD-right";
  }
  // Set CSS classname that set optional class on dropdown.
  let optionalCSS = "";
  if (optionalClassName) {
    optionalCSS = optionalClassName;
  }

  return `CAL-dropdown CAL-DDwBorder ${alignCSS} ${optionalCSS} js-nav-system__subnav`;
};

export interface IFancyDropdownOptionsProps {
  itemID?: string;
  alignment?: FancyDropdownAlignment;
  options: IFancyDropdownOptionProps[];
  optionalClassName?: string;
}

export const FancyDropdownOptions = (props: IFancyDropdownOptionsProps) => {

  const divCSS = getDIVCSS(props.alignment, props.optionalClassName);

  const id = "options_" + props.itemID;

  return (
    <div className={divCSS}>
      {props.options.length > 0 &&
        <span className="triangle" aria-hidden="true"></span>
      }
      {props.options.length > 0 &&
        <ul role="menu" id={id}>
          {props.options.map((option, i) => {
            return (
              <FancyDropdownOption key={i} {...option} />
            );
          })}
        </ul>
      }
    </div>
  );

};
